export const API_URL = 'https://qr-table.com/api'; // Update with your backend URL
